import i18n from 'i18next'
import {format} from 'ag-common/facades'
import {chain} from 'lodash'
import getAusbildungsjahr from '#tools/getAusbildungsjahr'

import * as types from './filterDialogTypes'

const filterTypesMeineAzubis = [
  {
    type: types.AZUBI_NAME,
    text: 'meineazubis_header_name',
  },
  {
    type: types.AZUBI_JOB,
    text: 'meineazubis_header_beruf',
  },
  {
    type: types.AZUBI_MARKET,
    text: 'meineazubis_header_markt',
  },
  {
    type: types.AZUBI_START,
    text: 'meineazubis_header_startdate',
  },
  {
    type: types.AZUBI_YEAR,
    text: 'meineazubis_header_year',
  },
  {
    type: types.AZUBI_NACHWEIS,
    text: 'meineazubis_header_nachweistyp',
  },
]

const filterTypesVersetzungplan = [
  {
    type: types.AZUBI_JOB,
    text: 'meineazubis_header_beruf',
  },
  {
    type: types.AZUBI_MARKET,
    text: 'meineazubis_header_markt',
  },
  {
    type: types.AZUBI_YEAR,
    text: 'meineazubis_header_year',
  },
  {
    type: types.AZUBI_ABTEILUNG,
    text: 'ablaufundtermine_header_abteilung',
  },
]

export function extractFilterOptionsVersetzungplan(azubis, versetzungsplan) {
  const azubiOptions = getAzubiOptions(azubis)
  const filterOptionsDictionary = filterTypesVersetzungplan.map(type => {
    let options
    if (type.type === types.AZUBI_ABTEILUNG) {
      options = getAbteilungsOptions(versetzungsplan)
    } else {
      options = makeOptionsUnique(type.type, azubiOptions)
    }
    return {
      type: type.type,
      displayName: i18n.t(type.text),
      options,
    }
  })

  return filterOptionsDictionary
}

export function extractEmptyFilterOptionsVersetzungplan() {
  const filterOptionsDictionary = filterTypesVersetzungplan.map(type => ({
    type: type.type,
    displayName: i18n.t(type.text),
    options: [],
  }))

  return filterOptionsDictionary
}

export function extractFilterOptionsMeineAzubis(azubis) {
  const azubiOptions = getAzubiOptions(azubis)
  const filterOptionsDictionary = filterTypesMeineAzubis.map(type => ({
    type: type.type,
    displayName: i18n.t(type.text),
    options: makeOptionsUnique(type.type, azubiOptions),
  }))
  return filterOptionsDictionary
}

export const getAbteilungsOptions = versetzungsplan => {
  const namesAbteilungen = versetzungsplan.filter(e => e.abteilung).map(a => a.abteilung.name)
  return [...new Set(namesAbteilungen)].sort()
}

export const getAzubiOptions = azubis =>
  azubis.map(azubi => {
    const ausbildungsstart = new Date(azubi.ausbildungsstart)

    const ausbildungsJahr = getAusbildungsjahr(ausbildungsstart)

    return {
      [types.AZUBI_NAME]: `${azubi.lastname} ${azubi.firstname}`,
      [types.AZUBI_JOB]: azubi.ausbildungsBerufString,
      [types.AZUBI_START]: format(ausbildungsstart, 'dd.MM.yyyy'),
      [types.AZUBI_YEAR]: i18n.t('meineazubis_ausbildungsjahr', [ausbildungsJahr]),
      [types.AZUBI_NACHWEIS]: i18n.t(azubi.ausbildungsnachweisTyp),
      [types.AZUBI_MARKET]: azubi.markt,
    }
  })

const formatDateToBeCompared = datestring => datestring.split('.').reverse().join('')

const sortedByDateAsString = (azubiList, searchItem) =>
  chain(azubiList)
    .map(azubi => {
      if (azubi[searchItem] === undefined) {
        return ''
      }
      return azubi[searchItem]
    })
    .sortBy(each => formatDateToBeCompared(each))
    .sortedUniq()
    .value()

export const makeOptionsUnique = (type, azubiList) => {
  if (type === 'ausbildungsstart') {
    return sortedByDateAsString(azubiList, type)
  }
  return chain(azubiList)
    .map(azubi => {
      if (azubi[type] === undefined) {
        return ''
      }
      return azubi[type]
    })
    .sortBy()
    .sortedUniq()
    .value()
}
